import React, { Component } from 'react';

import { connect } from "react-redux";
import * as vignetsActions from "../../actions/vignets";

import {withRouter} from 'react-router';

import VignetNewItem from './VignetNewItem';
import ListItem from '../common/listItem';
import {BUILDER_PATH} from "../../constants";

import Loader from 'react-loader-spinner';
import AuthService from '../../lib/AuthService';

class VignetContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            showPop : false,
            showShare : false,
            showStat : true
        };
        this.Auth = new AuthService();
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.showShare = this.showShare.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.listenToScroll=this.listenToScroll.bind(this);
    }


    componentDidMount() {
        //this.forceUpdateHandler(10);
        this.forceUpdateHandler('50');

        const container = document.querySelector('.right-bottom-area');
        container.addEventListener('scroll', this.listenToScroll);
        this.getProjects();

    }

    componentWillUnmount() {
        const container = document.querySelector('.right-bottom-area');
        container.removeEventListener('scroll', this.listenToScroll)
    }

    listenToScroll = () => {
        const container = document.querySelector('.right-bottom-area')
        let lastOffset = document.querySelector('.list-container').childElementCount-1;
        var scrollTop = container.scrollTop;
        var scrollHeight = container.scrollHeight;
        var offsetHeight = container.offsetHeight;
        var contentHeight = scrollHeight - offsetHeight;

       // console.log(scrollTop+"----"+scrollHeight+"----"+offsetHeight+"-----"+contentHeight);

        if (contentHeight <= scrollTop) {
            let plId = "";

            let data = { user_id : this.Auth.getProfile().user_id , size : 50, type : 'list',  playlistId : plId?plId:'', offset : lastOffset};
            this.props.moreVignetsData(data);
        }

    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.vignetsData.vignetsDeleted !== prevProps.vignetsData.vignetsDeleted || this.props.vignetsData.vignetCreated !== prevProps.vignetsData.vignetCreated) {
            this.forceUpdateHandler();
        }

        if (this.props.vignetsData.vignetsJoined !== prevProps.vignetsData.vignetsJoined ) {
            window.open(BUILDER_PATH+this.props.vignetsData.newJoinedUrl,'_blank');
        }
        if (this.props.vignetsData.searchText !== prevProps.vignetsData.searchText ) {

        }

        if (this.props.vignetsData.vignetCreated !== prevProps.vignetsData.vignetCreated) {
            window.open(BUILDER_PATH+this.props.vignetsData.builderUrl,'_blank');
        }

        /*if(this.props.vignetsData.vignetsList !== prevProps.vignetsData.vignetsList) {
            for(var i=0; i< this.props.vignetsData.vignetsList.length; i++) {
                if( !this.props.vignetsData.vignetsList[i].eventTracks ) {
                    this.getVigProps(this.props.vignetsData.vignetsList[i].uniqueId , i , 'list');
                }
            }
        }*/
    }


    forceUpdateHandler(size, offset){
        let plId = "";
        console.log(this.props);
        /*if( this.props.match.path === "/playlist/add/:id") {
            plId = this.props.match.params.id;
        }*/
        let data = { user_id : this.Auth.getProfile().user_id , size : size?size:'', type : 'list',  playlistId : plId?plId:'', offset : offset?offset:0};
        this.props.allVignetsData(data);
    }

    getVigProps(vigId, itemIndex, section_name){
        let data = { vignet_id : vigId, section : 'list', index : itemIndex , section_name : section_name };
        // console.log(data)
        this.props.allVignetsProps(data);
        // console.log(this.props.vignetsData.vignetProps);
    }

    showDetailPopup(vignet) {

        this.setState(
            {
                showPop: true,
                vignet : vignet
            },
            () => {
                console.log(this.state.showDetailPop);
                console.log(this.state.vignet);
            });

        //this.setState({playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].name:''});

    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
    }

    toggle() {
        console.log(this.state.showCopyMsg);
        this.setState({
            showCopyMsg: !this.state.showCopyMsg
        });
    }

    showShare() {
        this.setState({
            showShare: true,
            showStat : false
        });
    }

    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.Auth.getProfile().user_id;

        var e = document.createElement("textarea");
        var url ="https://a.vignets.com/react-vignet/player/?"+vigID+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {


        var baseUrl =String('https://a.vignets.com/react-vignet/player/?'+vignet_id);

        let rootUrl = '';let shareUrl ='';


        if(type === 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type === 'fb') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type === 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }

        window.open(shareUrl);

    }
    getProjects(searchText) {
        this.props.getProjects({searchText: searchText});
    }

    render() {

        let vignetsList = (this.props.vignetsData.searchText || this.props.vignetsData.sort) ? this.props.vignetsData.filteredData :  this.props.vignetsData.vignetsList;
        console.log(this.props.vignetsData.vignetsList)
        return (
            <div className="list-wrap">
                <div className="list-container">

                    {!vignetsList &&
                        <div className="loaderWrapper">
                            <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                        </div>
                    }

                    <div className="panel-block new-panel" onClick={() => {this.props.modalToggle({ modalOpen : true, modalTitle : "Add Vignet", "modalType" : "new-vig"})}}>

                        <div className="gallery-thumb">
                            <div className="new-button-block">
                                <button className="icon-lib add-button float-add"></button>
                                <p>Add Vignet</p>
                            </div>
                        </div>

                        <VignetNewItem getProjects={this.getProjects.bind(this)}/>

                    </div>


                    {vignetsList &&
                    vignetsList.map((entry, index) => <ListItem detail={entry} id={index}  showDetailPopup={this.showDetailPopup.bind(this)} itemType="vignets" />)

                    }


                </div>



            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        vignetsData  :state.vignets.vignetsData,
        playlistData  :state.playlist.playlistData
    };

}
export default  withRouter(connect(mapStateToProps, {
    allVignetsData : vignetsActions.fetchVignetsData,
    allFilteredData : vignetsActions.searchVignets,
    allVignetsProps : vignetsActions.getVignetProps,
    modalToggle : vignetsActions.toggleModal,
    moreVignetsData : vignetsActions.fetchmoreVignetsData,
    getProjects : vignetsActions.getProjects,
})(VignetContainer));



// WEBPACK FOOTER //
// ./src/components/vignets/VignetContainer.js